module.exports = __webpack_public_path__ + "static/media/home2icons3.f6172064.svg";